import React from "react";
import { Avatar, Button, DetailCard } from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";

const WorkExperience = ({ applicant }) => {
  const workHistory = applicant?.workHistory || [];

  return (
    <div className="p-4">
       <div className="mb-4 font-semibold text-sm">
        Total Experience: {applicant?.exp?.year} year(s) {applicant?.exp?.mon} month(s)
      </div>
      {workHistory.map((item) => {
        const jobTitle = formatWords2(item?.jobDetails?.title || "—");
        const jobDescription = item?.jobDetails?.description || "—";

        const fromDate = item?.joined?.from
          ? new Date(item.joined.from).toLocaleDateString()
          : "—";

        const toDate = item?.joined?.to
          ? new Date(item.joined.to).toLocaleDateString()
          : "—";

       return (
          <div key={item._id} className="mb-4">   {/* <-- Space between cards */}
            <DetailCard
              size="xs"
              title={
                <div className="flex items-center gap-x-5 gap-y-2">
                  <Avatar showInitials alt={jobTitle} noBorder />
                  <div className="font-bold text-xs">
                    {fromDate} → {toDate}
                  </div>
                </div>
              }
              headeRight={
                <div className="p-2">
                  <Button
                    icon={"more_vert"}
                    variant="text"
                    type="icon"
                    size="sm"
                    color="black"
                  />
                </div>
              }
            >
              <div className="my-2 mx-1 text-sm p-2">
                <div className="font-semibold text-sm">{jobTitle}</div>
                <div className="mt-1">
                  {jobDescription || "No description"}
                </div>
              </div>
            </DetailCard>
          </div>
        );
      })}
    </div>
  );
};

export default WorkExperience;
